import { Layout, Text } from '@loadsmart/loadsmart-ui'

type QuoteItemProps = {
  label: string
  value: string
}

export function QuoteItem({ label, value }: QuoteItemProps) {
  return (
    <Layout.Stack space="xs">
      <Text variant="heading-sm-bold">{label}</Text>
      <Text>{value}</Text>
    </Layout.Stack>
  )
}
